<div class="flex-fill d-flex flex-column w-100">
  <div class="date-select-card">
    <div class="d-flex flex-row align-items-center">
      <label class="me-3">Schedule Date</label>
      <dx-date-box style="max-width: '150px'" [(value)]="scheduleDate" (onValueChanged)="onDateChanged()"></dx-date-box>
      <button (click)="changeDate(-1)" class="btn btn-sm btn-secondary ms-4 me-2" style="min-width: 100px">Previous</button>
      <button (click)="changeDate(1)" class="btn btn-sm btn-secondary me-2" style="min-width: 100px">Next</button>
      <button class="btn btn-sm btn-success me-4" (click)="refresh()">Refresh Data</button>
      <button class="btn btn-sm btn-primary me-2" (click)="addJobNote()" [hidden]="!isScheduleAdmin">Add Note</button>
    </div>
  </div>
  <div id="kanban" class="flex-fill d-flex flex-row">
    @if (storageDumpSitesList) {
      <div class="d-flex flex-column">
        <div class="list-title dx-theme-text-color">{{ 'Storage & Dump Sites' }}</div>
        <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
          <dx-sortable
            class="sortable-cards"
            group="cardsGroup"
            [data]="storageDumpSitesList"
            (onDragStart)="onstorageDumpSitesDragStart($event)"
            (onReorder)="onstorageDumpSitesDrop($event)"
            (onAdd)="onstorageDumpSitesDrop($event)"
            >
            @for (site of storageDumpSitesList.storageDumpSites; track site) {
              <div
                class="card dx-card dx-theme-text-color dx-theme-background-color text-wrap"
                >
                <div class="card-priority" [ngClass]="site.storage ? 'priority-5' : 'priority-2'"></div>
                <div>{{ site.name }}</div>
                <div class="card-assignee card-subject">
                  <a [routerLink]="[]" (click)="openMaps(site)">{{ site.displayAddress }}</a>
                </div>
                @if (site.storage) {
                  <div class="card-assignee card-subject" style="color: red; font-weight: bold">
                    <span [innerHTML]="site.locationsHTML"></span>
                  </div>
                }
              </div>
            }
          </dx-sortable>
        </dx-scroll-view>
      </div>
    }
    @if (unAssignedJobs) {
      <div class="d-flex flex-column">
        <div class="list-title dx-theme-text-color">{{ 'UnAssigned' }}</div>
        <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
          <dx-sortable
            class="sortable-cards"
            group="cardsGroup"
            [data]="unAssignedJobs"
            (onDragStart)="onTaskDragStart($event)"
            (onReorder)="onTaskDrop($event)"
            (onAdd)="onTaskDrop($event)"
            >
            @for (job of unAssignedJobs.assignedJobs; track job) {
              <div
                id="unassigned-job-card"
                        [class]="
                            'flex-row card dx-card dx-theme-text-color dx-theme-background-color text-wrap' +
                            (job.extraExpense ? ' card-extraExpense' : '')
                        "
                (contextmenu)="onContextMenu(job.id)"
                >
                <div class="flex-fill">
                  <div class="card-priority" [ngClass]="'priority-' + job.Task_Priority"></div>
                  @if (job.rentalId) {
                    <div class="card-assignee">{{ job.rental.customer.displayName }}</div>
                  }
                  @if (!job.completed && job.jobTypeId !== 6 && job.jobTypeId !== 7 && job.preferredStartTime) {
                    <div
                      class="card-subject"
                      >
                      {{ job.preferredStartTime | date : 'shortTime'
                      }}{{ job.preferredEndTime ? '-' + (job.preferredEndTime | date : 'shortTime') : '' }}
                    </div>
                  }
                  @if (!job.completed && job.jobTypeId !== 6 && job.jobTypeId !== 7 && job.address1) {
                    <div class="card-subject">
                      <a [routerLink]="[]" (click)="openMaps(job)">{{ job.address1 }} {{ job.city }}</a>
                    </div>
                  }
                  <div class="card-subject">
                    {{ job.displayId }}: {{ job.dumpsterId ? job.dumpster.size + ' -' : '' }} {{ job.scheduleJobTypeName }}
                  </div>
                  @if (!job.rentalId) {
                    <div class="card-subject">{{ job.displayAddress }}</div>
                  }
                </div>
                <div class="d-flex flex-fill align-items-center" style="min-width: 10px; max-width: 25px">
                  @if (job.recurringJobId) {
                    <i class="fa fa-repeat ms-1" style="color: #bc7700" aria-hidden="true"></i>
                  }
                </div>
              </div>
            }
          </dx-sortable>
        </dx-scroll-view>
      </div>
    }

    <dx-scroll-view class="scrollable-board" direction="horizontal" showScrollbar="always">
      <dx-sortable
        class="sortable-lists"
        [data]="driverColumns"
        itemOrientation="horizontal"
        handle=".list-title"
        (onDragStart)="onListDragStart($event)"
        (onReorder)="onListReorder($event)"
        >
        @for (driver of driverColumns; track driver) {
          <div class="list">
            <div class="list-title dx-theme-text-color">{{ driver.name }}</div>
            <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
              <dx-sortable
                class="sortable-cards"
                group="cardsGroup"
                [data]="driver"
                (onDragStart)="onTaskDragStart($event)"
                (onReorder)="onTaskDrop($event)"
                (onAdd)="onTaskDrop($event)"
                >
                @for (assignedJob of driver.assignedJobs; track assignedJob) {
                  <div
                    id="job-card"
                                [class]="
                                    'flex-row card dx-card dx-theme-text-color dx-theme-background-color text-wrap' +
                                    (assignedJob.completed
                                        ? ' card-completedJob'
                                        : assignedJob._nonCDRDumpster
                                        ? ' card-other-salesperson'
                                        : '') +
                                    (assignedJob.extraExpense ? ' card-extraExpense' : '')
                                "
                    (contextmenu)="onContextMenu(assignedJob.id)"
                    >
                    <div class="flex-fill">
                      @if (!assignedJob.completed) {
                        <div
                          class="card-priority"
                          [ngClass]="'priority-' + assignedJob.jobTypeId"
                        ></div>
                      }
                      <div class="card-assignee">{{ assignedJob.rental?.customer?.displayName }}</div>
                      @if (
                        !assignedJob.completed &&
                        assignedJob.jobTypeId !== 6 &&
                        assignedJob.jobTypeId !== 7 &&
                        assignedJob.preferredStartTime
                        ) {
                        <div
                          class="card-subject"
                          >
                          {{ assignedJob.preferredStartTime | date : 'shortTime'
                          }}{{
                          assignedJob.preferredEndTime ? '-' + (assignedJob.preferredEndTime | date : 'shortTime') : ''
                          }}
                        </div>
                      }
                      @if (
                        !assignedJob.completed &&
                        assignedJob.jobTypeId !== 6 &&
                        assignedJob.jobTypeId !== 7 &&
                        assignedJob.address1
                        ) {
                        <div
                          class="card-subject"
                          >
                          <a [routerLink]="[]" (click)="openMaps(assignedJob)"
                            >{{ assignedJob.address1 }} {{ assignedJob.city }}</a
                            >
                          </div>
                        }
                        @if (assignedJob.rentalId || assignedJob.jobTypeId === 7) {
                          <div class="card-subject">
                            <!-- J{{ assignedJob.id }}: {{ assignedJob.dumpsterId ? assignedJob.dumpster.size + ' -' : '' }}
                            {{ assignedJob.jobType.name }} {{assignedJob.jobTypeId === 3 || assignedJob.jobTypeId === 4 ? assignedJob.action?.name : ''}} -->
                            {{ assignedJob.scheduleJobTypeName }}
                          </div>
                        }
                        @if (!assignedJob.rentalId) {
                          <div class="card-subject">
                            {{ assignedJob.siteName }}
                          </div>
                        }
                        <div class="card-subject">Time: {{ assignedJob._totalTime.toFixed(2) ?? 0 }}</div>
                      </div>
                      <div class="d-flex flex-fill align-items-center" style="min-width: 10px; max-width: 25px">
                        @if (assignedJob._isStarted) {
                          <i
                            class="fa fa-clock-o me-1"
                            style="color: #028d00"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (assignedJob._isPaused) {
                          <i
                            class="fa fa-pause-circle me-1"
                            style="color: #575757"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (!assignedJob.completed && !!assignedJob.notes) {
                          <i
                            class="fa fa-exclamation"
                            style="color: red"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (assignedJob.completed) {
                          <i
                            class="fa fa-check-circle fa-2"
                            style="color: #028d00"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (assignedJob.trailerUsed) {
                          <i
                            class="fa fa-truck ms-1"
                            style="color: #02008d"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (assignedJob.recurringJobId) {
                          <i
                            class="fa fa-repeat ms-1"
                            style="color: #bc7700"
                            aria-hidden="true"
                          ></i>
                        }
                      </div>
                    </div>
                  }
                </dx-sortable>
              </dx-scroll-view>
            </div>
          }
        </dx-sortable>
      </dx-scroll-view>
    </div>
  </div>
  <dx-context-menu target="#job-card" [dataSource]="jobContextMenuItems" (onItemClick)="onContextMenuItemClick($event)"> </dx-context-menu>
  <dx-context-menu target="#unassigned-job-card" [dataSource]="unassignedJobContextMenuItems" (onItemClick)="onContextMenuItemClick($event)">
  </dx-context-menu>
